'use strict';

var SITE = SITE || {
  data: {
    url: '',
    $body: $('body'),
    $window: $(window),
    $MQ: 'PC',
    scrollTop: 0,
    lockTop: 0,
    winW: '',
    winH: '',
    jqXHR: '',
    scrollTopflag: false,
    transitonEnd: 'webkitTransitionEnd mozTransitionEnd msTransitionEnd oTransitionEnd transitionend',
    animationStart: 'webkitAnimationStart mozAnimationStart msAnimationStart oAnimationStart animationStart',
    animationEnd: 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd'
  },
  pageScript: {
    init: {}
  }
};

SITE.pageScript = function () {

  // コンストラクタ  =================================================================
  function init() {
    getWindowSize();
    initMap();
    initFooterScroll();
    initMainVisual();

    if (sessionStorage.getItem('daibakusho_loaded')) {
      $('.js-intro').hide();
      $('.js-introBusy').show();
      $('.js-loadBusy').show();
    } else {
      var introAnimateTL = initTimeline();

      // 10秒経ってもロードが終わらない場合は強制でやる
      var alreadyShow = false;
      var timeoutTimer = setTimeout(function () {
        alreadyShow = true;
        $('.js-intro').hide();
        $('.js-loadBusy').show();
      }, 10000);

      countImgLoaded().then(function () {
        if (!alreadyShow) {
          clearTimeout(timeoutTimer);
          $('.js-introBusy').show();
          introAnimateTL.play();
          sessionStorage.setItem('daibakusho_loaded', true);
        }
      }).catch(function () {
        if (!alreadyShow) {
          $('.js-intro').hide();
          $('.js-loadBusy').show();
        }
      });
    }
  }

  // private functions  ==========================================================
  /**
   * 画像読み込み数カウント
   */
  function countImgLoaded(target, runnninng) {
    var deferred = new $.Deferred();

    var $img = target ? target.find('img') : $('img');
    var total = $img.length;
    var count = 0;

    $img.each(function () {
      var myImg = new Image();

      myImg.src = $(this).attr('src');

      myImg.onload = function () {
        count++;

        var progress = count / total;
        if (runnninng) {
          runnninng(progress);
        }

        if (count >= total) {
          deferred.resolve();
        }
      };
      myImg.onerror = function () {
        deferred.reject();
      };
    });

    return deferred.promise();
  }

  /**
   * サイズ取得
   */
  function getWindowSize() {
    SITE.data.winW = SITE.data.$window.width();
    SITE.data.winH = SITE.data.$window.height();

    var mWidth = $('body').css('min-width');
    switch (mWidth) {
      case '2px':
        SITE.data.$MQ = 'SP';
        break;
      default:
        SITE.data.$MQ = 'PC';
    }

    if (SITE.data.oldMQ && SITE.data.oldMQ !== SITE.data.$MQ) {
      SITE.data.$window.trigger('onBreakpointChange');
    }

    SITE.data.oldMQ = SITE.data.$MQ;
  }

  /**
   * メインビジュアルアニメーションの設定
   */
  var initMainVisual = function initMainVisual() {
    toggleSomeCard();

    var timer = setInterval(function () {
      toggleSomeCard();
    }, 3000);

    return timer;
  };
  var toggleSomeCard = function toggleSomeCard() {
    var max = $('.js-card.show-b').length - 1;
    var ran = Math.floor(Math.random() * max);

    var $newTarget = $('.js-card.show-b').eq(ran);
    $('.js-card.show-a').toggleClass('show-a show-b');
    $newTarget.toggleClass('show-a show-b');
  };

  /**
   * イントロアニメーションの設定
   */
  var initTimeline = function initTimeline() {
    var TL = gsap.timeline({ paused: true });

    TL.addLabel('step1', 0).addLabel('step2', 'step1+=1').addLabel('step3', 'step2+=1').addLabel('step4', 'step3+=1');

    TL.set('.js-title', { opacity: 0, y: 20 }, 'step1').set('.js-logoSmile', { width: 0 }, 'step1').set('.js-dai', { x: 88 }, 'step1').set('.js-baku', { x: -88 }, 'step1').set('.js-meriyasu', { opacity: 1 }, 'step1').set('.js-daibakusho', { opacity: 0 }, 'step1');

    TL.seek('step1');

    // step1
    TL.to('.js-background', { scale: 1.075, duration: 4 }, 'step1').to('.js-title', { opacity: 1, y: 0, duration: 1 }, 'step1');

    // step2
    TL.to('.js-dai', { x: 66, y: -10, scale: .75, duration: .15 }, 'step2+=0.4').to('.js-dai', { x: 44, y: -15, scale: .5, duration: .15 }, 'step2+=0.55').to('.js-dai', { x: 22, y: -10, scale: .75, duration: .15 }, 'step2+=0.7').to('.js-dai', { x: 0, y: 0, scale: 1, duration: .15 }, 'step2+=0.85').to('.js-baku', { x: -66, y: 10, scale: 1.25, duration: .15 }, 'step2+=0.4').to('.js-baku', { x: -44, y: 15, scale: 1.5, duration: .15 }, 'step2+=0.55').to('.js-baku', { x: -22, y: 10, scale: 1.25, duration: .15 }, 'step2+=0.7').to('.js-baku', { x: 0, y: 0, scale: 1, duration: .15 }, 'step2+=0.85').to('.js-logoSmile', { width: 147, duration: .2 }, 'step2+=0.3').to('.js-meriyasu', { opacity: 0, duration: 1.5 }, 'step2+=0.2').to('.js-daibakusho', { opacity: 1, duration: 1.5 }, 'step2+=0.2');

    // step3
    TL.to('.js-screen1', { height: '100%', duration: .2 }, 'step3+=0.3').to('.js-screen2', { height: '100%', duration: .4 }, 'step3+=0.35');

    // step4
    TL.to('.js-intro', { opacity: 0, duration: 1.4 }, 'step4+=0.2').then(function () {
      $('.js-intro').hide();
      $('.js-loadBusy').show();
    });

    return TL;
  };

  /**
   * マップスクロール
   */
  var initMap = function initMap() {
    if (SITE.data.$MQ == 'SP') {
      $('.js-map').on('click', function () {
        $('.js-zoomMap').fadeIn();
      });
      $('.js-zoomClose').on('click', function (e) {
        e.stopPropagation();
        $('.js-zoomMap').fadeOut();
      });
    }
  };

  /**
   * フッターのスクロールアニメーション
   */
  var initFooterScroll = function initFooterScroll() {
    if (SITE.data.$MQ != 'SP') {
      return false;
    }
    var TL = gsap.timeline({ repeat: -1 });
    TL.to('.js-scrollAnimate', { x: '-66.7%', ease: 'none', duration: 100 }).set('.js-scrollAnimate', { x: 0 });
  };

  return {
    init: init
  };
}();

SITE.pageScript.init();